import { render } from "./TokenInvalido.vue?vue&type=template&id=43b65682&ts=true"
import script from "./TokenInvalido.vue?vue&type=script&lang=ts"
export * from "./TokenInvalido.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__